import React, { useMemo, useState } from 'react';
import { WarningIcon } from '@parchment/icons';
import { Banner, curiousBlue, white, emperor } from '@parchment/atoms';
import { MessageBannerContext, MessageContext } from '../common/constants/MessageConstants';
import styled from 'styled-components';

export default function MemberMessages ({
    memberServiceMessages = {},
    pageLocation = '',
    userRole = '',
    messageContexts = []
}) {
    const [ availableMessages, setAvailableMessages ] = useState([]);

    const filterMessages = () => {
        const messages = memberServiceMessages?.globalMessages?.concat(
            memberServiceMessages?.associatedMemberMessages?.concat(memberServiceMessages?.memberMessages)
        );
        //filter location
        let filteredMessage = messages.filter((message) => {
            const filterMess = message.messageDisplayLocations.find((displayLocation) => {
                return displayLocation === pageLocation;
            });
            if(filterMess) {
                return message;
            }
        });
        //filter user roles
        filteredMessage = filteredMessage.filter((message) => {
            const filterMessageByRole = message.messageUserRoles.find((role) => {
                return role === userRole;
            });
            if(filterMessageByRole) {
                return message;
            }
        });
        if(messageContexts.length > 0) {
            filteredMessage = filteredMessage.filter((message) => {
                const filterMessageByContext = messageContexts.find((context) => {
                    return context === message.messageContext;
                });
                if(filterMessageByContext) {
                    return message;
                }
            });
        }
        return filteredMessage;
    };

    const getContext = (memberMessage) => {
        switch (memberMessage.messageContext) {
            case MessageContext.ALERT:
                return MessageBannerContext.WARNING;
            case MessageContext.SIMPLE:
                return MessageBannerContext.DARK;
            default:
                return MessageBannerContext.LIGHT;
        }
    };

    useMemo(() => {
        //user is tpo for other
        setAvailableMessages(filterMessages());
    },[pageLocation, userRole]);

    const renderMessages = () => {
        return availableMessages.map((memberMessage) => {
            if(memberMessage.messageContext === MessageContext.SIMPLE) {
                return (
                    <SimpleMessageBanner
                        key={memberMessage.uuid}
                        icon={<WarningIcon />}
                        title={memberMessage.messageTitle}
                        message={memberMessage.messageContent}
                        actionType={'link'}
                        action={memberMessage.displayLink ? memberMessage.linkDescription : null}
                        actionLink={memberMessage.displayLink ? memberMessage.linkUrl : null}
                        context={getContext(memberMessage)}
                        hideIcon
                        isTransparent
                    />
                );
            } else {
                return (
                    <MessageBanner
                        key={memberMessage.uuid}
                        icon={<WarningIcon />}
                        title={memberMessage.messageTitle}
                        message={memberMessage.messageContent}
                        actionType={'link'}
                        action={memberMessage.displayLink ? memberMessage.linkDescription : null}
                        actionLink={memberMessage.displayLink ? memberMessage.linkUrl : null}
                        context={getContext(memberMessage)}
                    />
                );
            }
        });
    };

    return (
        <div>
            {availableMessages.length > 0 && renderMessages()}
        </div>
    );
}
const getBannerContextColor = (context) => {
    switch (context) {
        case MessageBannerContext.WARNING:
            return white;
        case MessageBannerContext.LIGHT:
            return emperor;
        case MessageBannerContext.DARK:
        default:
            return curiousBlue;
    }
};

/*
* Needed due to aura injecting its own styles
* Also yes there is an ugly important :)
* */
const MessageBanner = styled(Banner)`
  a {
    color: ${props => getBannerContextColor(props.context)} !important;
    &:hover {
      opacity: 0.8
    }
  }
`;

const SimpleMessageBanner = styled(MessageBanner)`
    padding: 0;
    div {
      margin: 10px 0;
    }
`;
